import PropTypes from 'prop-types';
import React from 'react';
import {connect} from 'react-redux';
import {withRouter} from 'react-router';
import {compose} from 'redux';
import {Segment} from 'semantic-ui-react';

import {graphql, withApollo} from 'react-apollo';
import HeaderRenderer from '@appComponents/HeaderRenderer';
import {getLink} from '@appComponents/Link';
import {convertToInt} from '@utils/helpers';
import {routes} from '@constants/routes';
import {PRODUCT_THIRD_PARTY} from '@constants/variables';
import ThirdPartyTunnelsIndexButtons from '@modules/client/components/ThirdPartyTunnelsIndexButtons';
import ThirdPartyTunnelsTable from '@modules/client/components/ThirdPartyTunnelsTable';
import ClientTunnelModalContent
    from '@modules/client/forms/ClientPackageTunnels/OutputClientReferences/ClientTunnelModalContent';
import {showModal} from '@utils/modal';

import {GetThirdPartyTunnelsForTable} from '../../../graphql/thirdPartyClientTunnel/query.graphql';
import {exportExcel} from '../utils/export/thirdPartyTunnelsIndexExcel';
import mapModulesToProps from '../../../utils/mapModulesToProps';

export class ThirdPartyTunnelsIndex extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            match: this.props.match,
            modal: this.props.modal,
            modalWasClosed: false,
            shouldOpenModal: false,
        };
    }

    static propTypes = {
        clientId: PropTypes.number.isRequired,
        DataThirdPartyTunnels: PropTypes.shape({
            loading: PropTypes.bool,
            thirdPartyClientTunnels: PropTypes.arrayOf(PropTypes.object),
            vtdTunnels: PropTypes.arrayOf(PropTypes.object),
        }),
        history: PropTypes.shape({
            push: PropTypes.func.isRequired,
        }),
        match: PropTypes.object.isRequired,
        modal: PropTypes.shape({
            isVisible: PropTypes.bool.isRequired,
        }),
        Modal: PropTypes.shape({
            setModal: PropTypes.func.isRequired,
        }),
        thirdParty: PropTypes.number.isRequired,
        prepareThirdPartyClientTunnelsForStore: PropTypes.func.isRequired,
    };

    static defaultProps = {
        DataThirdPartyTunnels: {
            loading: false,
            thirdPartyClientTunnels: [],
        },
    };

    static getDerivedStateFromProps(nextProps, prevState) {
        const urlChanged = nextProps.match.path !== prevState.match?.path,
            urlIsNotIndex = nextProps.match.path !== routes.clients.products.thirdParty.tunnels.index.path,
            shouldOpenModal = urlChanged && urlIsNotIndex,
            modalChanged = nextProps.modal.isVisible !== prevState.modal?.isVisible,
            modalIsNotVisible = !nextProps.modal.isVisible,
            modalWasClosed = modalChanged && modalIsNotVisible;

        return {
            modal: nextProps.modal,
            match: nextProps.match,
            shouldOpenModal: shouldOpenModal,
            modalWasClosed: modalWasClosed,
        };
    }

    componentDidMount() {
        this.loadModal(this.props.match.path);
    }

    componentDidUpdate() {
        if (this.state.shouldOpenModal) {
            this.loadModal(this.props.match.path, this.props.match.params);
        }

        if (this.state.modalWasClosed) {
            this.props.history.push(
                getLink('clients.products.thirdParty.tunnels.index', {
                    id: this.props.match.params.id,
                })
            );
        }
    }

    loadModal(path, params = {}) {
        const id = this.props.match.params.thirdPartyClientTunnelId || params.thirdPartyClientTunnelId || 0;

        const variables = {
            optionsVariables: {
                products: [PRODUCT_THIRD_PARTY],
                id: parseInt(id),
                thirdPartyClientId: this.props.thirdParty,
            },
            thirdParty: this.props.thirdParty,
        };


        if (path === routes.clients.products.thirdParty.tunnels.add.path) {
            showModal({
                size: 'large',
                canBeDismissed: false,
                isVisible: true,
                header: null,
                content: <ClientTunnelModalContent variables={{addPath: true, ...variables}} props={this.props} formParams={params}/>,
            });
        } else if (path === routes.clients.products.thirdParty.tunnels.edit.path) {
            showModal({
                size: 'large',
                canBeDismissed: false,
                isVisible: true,
                header: null,
                content: <ClientTunnelModalContent variables={{addPath: false, id: parseInt(id), ...variables}} props={this.props} formParams={params}/>,
            });
        }

    }

    render() {
        return (
            <Segment
                basic
                className='--marginTopNegative-15 --paddingTop-0'
                loading={this.props.DataThirdPartyTunnels.loading}
            >
                <HeaderRenderer
                    exportExcelParams={exportExcel(
                        this.props.DataThirdPartyTunnels.thirdPartyClientTunnels,
                        this.props.clientId,
                        this.props.DataThirdPartyTunnels.vtdTunnels
                    )}
                    buttons={ThirdPartyTunnelsIndexButtons}
                    buttonsProps={{clientId: this.props.clientId}}
                    loading={this.props.DataThirdPartyTunnels.loading}
                />
                <ThirdPartyTunnelsTable
                    clientId={this.props.clientId}
                    loading={this.props.DataThirdPartyTunnels.loading}
                    thirdPartyClientTunnelsStorages={this.props.DataThirdPartyTunnels.thirdPartyClientTunnels}
                    vtdTunnels={this.props.DataThirdPartyTunnels.vtdTunnels}
                />
            </Segment>
        );
    }
}

const ThirdPartyTunnelsWithGraphQL = compose(
    graphql(GetThirdPartyTunnelsForTable, {
        skip: props => (null === props.thirdParty),
        options: (props) => {
            return {
                fetchPolicy: 'network-only',
                notifyOnNetworkStatusChange: true,
                variables: {
                    clientProductThirdParty: props.thirdParty,
                },
            };
        },
        name: 'DataThirdPartyTunnels',
    })
)(ThirdPartyTunnelsIndex);

const mapStateToProps = (state) => {
    let thirdPartyClientProduct = null;

    if (state.app.entities.client.clientProducts) {
        thirdPartyClientProduct = state.app.entities.client.clientProducts.find((clientProduct) => (
            PRODUCT_THIRD_PARTY === convertToInt(clientProduct.product.id)
        ));
    }

    return {
        client: state.app.entities.client,
        modal: state.modal,
        thirdParty: thirdPartyClientProduct
            ? convertToInt(thirdPartyClientProduct.third_party_client_product.id)
            : null,
    };
};
const mapDispatchToProps = mapModulesToProps(['Modal', 'MessageBox']);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withApollo(ThirdPartyTunnelsWithGraphQL)));
